"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Navbar = _interopRequireDefault(require("react-bootstrap/Navbar"));
var _ErrorBoundary = _interopRequireDefault(require("../ErrorBoundary"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
class FirstTierBoundary extends _ErrorBoundary.default {
  constructor(props) {
    super(props);
  }
  render() {
    /* istanbul ignore else */
    if (this.state.hasError) {
      return (
        /*#__PURE__*/
        // eslint-disable-next-line jsx-a11y/aria-role
        _react.default.createElement(_Navbar.default, {
          as: "div",
          expand: "lg",
          variant: "dark",
          className: "utility first-tier",
          role: ""
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "container"
        }, /*#__PURE__*/_react.default.createElement(_Navbar.default.Brand, {
          href: "https://www.massmutual.com/",
          rel: "noopener noreferer"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "mm-r-logo-lg-white",
          role: "img",
          "aria-label": 'MassMutual Logo'
        }))))
      );
    }
    return (
      /*#__PURE__*/
      // eslint-disable-next-line jsx-a11y/aria-role
      _react.default.createElement(_Navbar.default, {
        as: "div",
        expand: "lg",
        variant: "dark",
        className: "utility first-tier",
        role: ""
      }, this.props.children)
    );
  }
}
var _default = exports.default = FirstTierBoundary;